<template>
    <modal @close="close" dialog="modal-lg" class="reservation-modal payment dark-top">
        <div slot="title">
            <h2>Payment Options</h2>
            <h3>{{headerSubTitle}}</h3>
        </div>

        <div slot="body" class="bg-lighter">

            <div class="w-100 px-4 pt-4 bg-lightest">

                <div class="col-sm-12 d-flex flex-row justify-content-between">
                    <label>Select payment method</label>
                    <label>Amount Received</label>
                </div>

                <div class="col-sm-12 mt-3 pb-2" v-for="payment, index in tempBilling.payments">
                    <div class="row">
                        <div class="col-sm-9 d-flex flex-row flex-wrap">

                            <div class="payMethod radius-normal text-center border-medium py-3 d-flex flex-column justify-content-between mr-2 mb-2 pointer" @click="selectPayMethod(payment, paymentMethod)" :class="{selected: paymentMethod.id == payment.type}" v-for="paymentMethod in getPaymentTypeListAll">
                                <div>
                                    <i v-if="paymentMethod.icon" class="ico dark fs-largest m-0" :class="paymentMethod.icon"></i>
                                    <img v-else-if="paymentMethod.img" :src="paymentMethod.img" :alt="paymentMethod.description" style="max-width: 60%;">
                                </div>
                                <span class="payeLabel darkest font-weight-600">{{paymentMethod.description}}</span>
                            </div>

                        </div>

                        <div v-if="getIsLoadingCalculations" class="col-sm-3 d-flex justify-content-center">
                            <loader></loader>
                        </div>

                        <div v-else class="col-sm-3 d-flex align-items-start">
                            <div class="d-flex flex-row align-items-center">
                                <input type="number" step=".01" min="0" class="fs-largest w-100 text-right bg-lighter glued-right" v-model="payment.value" placeholder="0">
                                <div class="border-light glued-left fs-largest py-2 px-2">€</div>
                                <!-- <i class="ico ico-add fs-large color-1 mr-0 ml-3 pointer" @click="addPaymentOption" v-if="index == 0"></i>
                                <i class="ico ico-delete fs-large color-1 mr-0 ml-3 pointer" @click="removePaymentOption(index)" v-if="index > 0"></i> -->
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-12 row mx-0 px-0 pb-2 border-top-light pt-3">

                    <!-- <div class="col-sm-5 d-flex align-items-center">
                        <label class="mr-2">
                            Tresurer
                        </label>
                        <v-select v-if="editedTresurerList" :options="editedTresurerList" label="name" v-model="selectedTresurer" @input="treasurerChanged"></v-select>
                    </div> -->

                    <div class="col-sm-12 d-flex align-items-center">
                        <label class="mr-2">
                            Notes
                        </label>
                        <input type="text" class="w-100" v-model="tempBilling.payments[0].description">
                    </div>


                    <div class="col-sm-12 d-flex align-items-end my-2 justify-content-end">
                        <label class="mr-3">
                            Outstanding
                        </label>
                        <span class="fs-large font-weight-600" :class="{'color-6': outstandingAmout < 0, 'color-3': outstandingAmout == 0}">{{ formatPrice(outstandingAmout) }} €</span>
                        <label class="mx-3">
                            Total
                        </label>
                        <span class="fs-large font-weight-600" :class="{'color-6': outstandingAmout < 0, 'color-3': outstandingAmout == 0}">{{ formatPrice(getReservationCalculations.grandTotal) }} €</span>
                    </div>

                </div>

            </div>


        </div>

        <div slot="footer">
            <button type="button" :disabled="getIsAddingReservation" class="btn cancel widest" @click="cancel">Cancel</button>
            <button type="button" class="btn ok widest" :disabled="disabled || getIsAddingReservation" @click="save(false)">{{saveButtonLabel}}</button>
            <button type="button" class="btn blue ok widest" :disabled="disabled || getIsAddingReservation" @click="save(true)">{{saveAndPrintButtonLabel}}</button>
        </div>
    </modal>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import { reservationsMixin } from '@/mixins/reservations'
    import Modal from './Modal'
    import extendedVSelect from '@/extends/vue-select'
    import PrintJs from 'print-js'
    import TeamMemberPicker from '../TeamMemberPicker'
    import Loader from '@/tools/loaders/loader1'

    export default {
        data: function () {
            return {
                tempBilling: {
                    promoCode: "",
                    promoCodeDiscountType: null,
                    promoCodeDiscountCode: null,
                    discountType: 0,
                    discountValue: 0,
                    description: "",
                    details: {
                        vat: "",
                        businessName: "",
                        address: "",
                        city: "",
                        country: 176
                    },
                    invoices: null,
                    payments: [
                        {
                            type: 1,
                            value: null,
                            currency: "€",
                            description: null
                        }
                    ]
                },
                tresurerArr:[],
                selectedTresurer: null,
                treasurerSupplier: null,
                showBillingDetails: true,
                showNotes: false,
                selectedCountry: null,
                clickedSave: false,
                clickedSaveAndPrint: false,
            }
        },
        created: function() {
            //fill details that were filled on new reservation
            this.tempBilling.details = this.getReservation.billing.details
            this.setSelectedCountry(this.getReservation.billing.details.country)

            //set the discount on the temp object
            this.tempBilling.discountValue = this.reservation.billing.discountValue;

            //set tresurer as me
            this.selectedTresurer = this.tresurerMe

            //set value to pay as total
            this.tempBilling.payments[0].value = this.getReservationCalculations.grandTotal
        },
        mixins:[
            reservationsMixin
        ],
        computed: {
            ...mapGetters([
                'getReservation',
                'getCountries',
                'account',
                'getReservationCalculations',
                'getIsAddingReservation',
                'getPaymentTypeListAll',
                'getIsLoadingCalculations',
            ]),
            reservation: function() {
                return this.getReservation;
            },
            headerSubTitle: function() {
                return (this.reservation.customer.name? this.reservation.customer.name + ' | ' : '') + this.reservation.product.name + ' | ' + moment(this.reservation.event.start).format('DD.MM.YYYY hh:mm A')
            },
            disabled: function() {
                return false
            },
            costTotal: function() {
                let total = 0;
                let totalWithVat = 0;

                //ticket cost
                for(let personType of this.reservation.event.eventGenderPrices){
                    total += personType.value * personType.quantity;
                    totalWithVat += personType.valueCalculated * personType.quantity;
                }

                return {
                    total: total,
                    totalWithVat: totalWithVat
                }

            },
            totalInPyamentOptions: function() {
                let total = 0;

                for(let paymentOption of this.tempBilling.payments){
                    total += Number(paymentOption.value);
                }

                return total;
            },
            outstandingAmout: function() {
                return this.getReservationCalculations.grandTotal - this.totalInPyamentOptions
            },
            editedTresurerList: function() {
                let tresurerList = JSON.parse(JSON.stringify(this.tresurerArr));

                tresurerList.unshift(this.tresurerMe)


                return tresurerList;
            },
            tresurerMe: function() {
                let me = JSON.parse(JSON.stringify(this.account))
                me.name = me.name + ' (Me)'
                return me
            },
            saveButtonLabel: function () {
                if(this.clickedSave){
                    return 'Saving'
                }

                let referanceToMakeChanges = this.selectedSellerAccessList // this.selectedSellerUserAccessList or this.loggedUserAccessList

                if(!referanceToMakeChanges || !referanceToMakeChanges.channel){
                    return 'Save'
                }

                if(referanceToMakeChanges.channel.isInvoiceAutomatic == true){
                    return 'Save and Bill'
                } else if(referanceToMakeChanges.channel.isInvoiceAutomatic == false){
                    return 'Save'
                }
            },
            saveAndPrintButtonLabel: function () {
                if(this.clickedSave){
                    return 'Saving'
                }

                let referanceToMakeChanges = this.selectedSellerAccessList // this.selectedSellerUserAccessList or this.loggedUserAccessList

                if(!referanceToMakeChanges || !referanceToMakeChanges.channel){
                    return 'Save and print'
                }

                if(referanceToMakeChanges.channel.isInvoiceAutomatic == true){
                    return 'Save, Bill and print'
                } else if(referanceToMakeChanges.channel.isInvoiceAutomatic == false){
                    return 'Save and print'
                }
            }
        },
        methods: {
            ...mapActions([
                'createNewReservation',
                'closeModal',
                'printInvoice',
                'addFloatingNotification',
            ]),
            cancel: function() {
                this.close();
            },
            close: function() {
                this.closeModal();
            },
            save: function(print) {
                if(this.getIsAddingReservation == true || this.clickedSaveAndPrint == true || this.clickedSave == true){
                    this.$toasted.info('Already creating reservation, please wait.');
                    return false
                }

                if(print){
                    this.clickedSaveAndPrint = true
                } else {
                    this.clickedSave = true
                }


                //sets the correct treasurer for every payment row
                this.tempBilling.payments.map(payment => {
                    this.$set(payment, 'treasurerUserAccount', this.selectedTresurer)
                    this.$set(payment, 'treasurerSupplier', this.account.supplier)
                })
                // this.reservation.billingList[0].details = this.tempBilling.details;
                // this.reservation.billingList[0].description = this.tempBilling.description;
                // this.reservation.billingList[0].payments = this.tempBilling.payments;
                // this.reservation.billing = this.tempBilling;
                // this.reservation.billingList[0] = this.tempBilling;
                this.reservation.billing.payments = this.tempBilling.payments;

                this.createNewReservation({
                    supplierId: this.account.supplierId,
                    reservation: this.reservation
                }).then(response => {
                    let vm = this
                    this.clickedSave = false
                    this.clickedSaveAndPrint = false
                    if (response.status == 200) {
                        // this.$notify({
                        //       group: 'notifications',
                        //       position: 'bottom right',
                        //       title: null,
                        //       text: '<a href="/reservations/view/'+response.data.id+'" target="_blank"><h1>Ticket '+this.formatTicketNumber(response.data.id)+'</h1>'+response.data.customer.name+'<br>'+response.data.event.product.name+'</a>',
                        //       duration: 100000,
                        // });

                        this.addFloatingNotification(
                            {
                                type: -1,
                                title: 'Ticket '+this.formatTicketNumber(response.data.id),
                                message: response.data.customer.name+' <br>'+response.data.event.product.name,
                                bookingId: response.data.id,
                            },
                            'info',
                            {
                                link: '/reservations/view/'+response.data.id
                            }
                        )

                        this.$toasted.success('Reservation created successfully');
                        this.$router.push({ name: 'reservations' });
                        this.closeModal();

                        if(print){
                            axios.get('/api/booking/GetTicket', {
                                params: {
                                    supplierId: this.account.supplierId,
                                    bookingId: response.data.id,
                                    type: 'vertical'
                                }
                            }).then(responseTicket => {


                                this.openByteArrayNewTab(responseTicket.data)

                                //
                                // pdfWindow.print();
                                // pdfWindow.close();


                            })

                            // print invoice
                            let referanceToMakeChanges = this.selectedSellerAccessList // this.selectedSellerUserAccessList or this.loggedUserAccessList
                            if(response.data.bookingInvoices.length > 0 && response.data.bookingInvoices[0].id && referanceToMakeChanges.channel.isInvoiceAutomatic == true){
                                vm.printInvoice(response.data.bookingInvoices[0].id).then(responsePrintInvoice =>{
                                    if(responsePrintInvoice.status == 200){
                                        vm.openByteArrayNewTab(responsePrintInvoice.data)
                                    }
                                }).catch(err => {

                                })
                            }

                        }
                    }
                }).catch(err => {
                    this.clickedSave = false
                    this.clickedSaveAndPrint = false
                })
            },
            addPaymentOption: function() {
                this.tempBilling.payments.push({
                    type: {
                        id: 1,
                        description: "Cash"
                    },
                    value: null,
                    currency: "€"
                });
            },
            removePaymentOption: function(index) {
                this.tempBilling.payments.splice(index, 1)
            },
            selectPayMethod: function(payment, paymentMethod) {
                payment.type = paymentMethod.id
            },
            treasurerChanged: function(e) {
                this.selectedTresurer
            },
            setSelectedCountry: function(countryId) {
                this.selectedCountry = this.getCountries.filter(country => {
                    return country.id == countryId
                })[0]
            },
            selectedCountryChanged: function(e) {
                this.reservation.billing.details.country = e.id
            }
        },
        components: {
            Modal,
            vSelect: extendedVSelect,
            TeamMemberPicker,
            Loader
        },
        watch: {
            'getReservationCalculations': {
                handler: function () {
                    // console.log('getReservationCalculations changed');
                    //set value to pay as total
                    this.tempBilling.payments[0].value = this.getReservationCalculations.grandTotal
                },
                deep: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/_variables.scss';

    .payMethod{
        width: 103px;
        height: 72px;
        position: relative;

        .payeLabel{
            position: absolute;
            bottom: 7px;
            width: 100%;
        }

        &.selected{
            border-color: $darkest !important;
            border-width: 2px !important;
        }

        &:hover{
            background-color: $lighter;
        }
    }
</style>



// WEBPACK FOOTER //
// ReservationPay.vue?0accfff4